import { lazy, Suspense } from "react"
import { Outlet } from "react-router-dom"

import { SplashScreen } from "src/common/loading-screen"

// ----------------------------------------------------------------------

// Error
const Page404 = lazy(() => import("src/pages/error/404"))

const AtsPartnerInterviewPage = lazy(() => import("@/src/features/ats/pages/AtsPartnerInterviewPage"))

// ----------------------------------------------------------------------

export const mainRoutes = [
    {
        element: (
            <Suspense fallback={<SplashScreen />}>
                <Outlet />
            </Suspense>
        ),
        children: [
            { path: "interview/:hash", element: <AtsPartnerInterviewPage /> },
            { path: "404", element: <Page404 /> },
        ],
    },
]
